import { render, staticRenderFns } from "./v-radio.vue?vue&type=template&id=eee88a76&scoped=true&"
import script from "./v-radio.vue?vue&type=script&lang=js&"
export * from "./v-radio.vue?vue&type=script&lang=js&"
import style0 from "./v-radio.vue?vue&type=style&index=0&id=eee88a76&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eee88a76",
  null
  
)

export default component.exports